import type { PriceTransform } from "@intelligems/ig-types/dtos/variations";

export function applyPriceTransform(
  value: number | string | null | undefined,
  transform: PriceTransform | undefined
) {
  if (typeof value === "string") {
    value = Number(value);
  }
  if (value === undefined || value === null || transform === undefined) {
    return value;
  }
  if (isNaN(value)) {
    return undefined;
  }

  if (transform.changeUnit === "dollar") {
    value = value + transform.change;
  } else {
    value = value * (1 + transform.change / 100);
  }

  value = Math.round(value * 100) / 100;

  const roundingAmount = transform.roundingAmount ?? 0;
  const offset = 1 - (roundingAmount % 1);
  switch (transform.roundingType) {
    case "nearest":
      value = Math.round(value + offset) - offset;
      if (value < 0) {
        value++;
      }
      break;
    case "down":
      value = Math.floor(value + offset) - offset;
      if (value < 0) {
        value++;
      }
      break;
    case "up":
      value = Math.ceil(value + offset) - offset;
      if (value < 0) {
        value++;
      }
      break;
  }
  return value;
}
